import Lookup from 'src/componentes/select-async';
import CargoEdit from 'src/paginas/remuneracao-variavel/cargo/edit';
import CargoView from 'src/paginas/remuneracao-variavel/cargo/view';

const CargoLookup = (props) => {
  return (
    <Lookup
      valueKey="id"
      labelKey="nome"
      showSearch
      showNew={true}
      url="/CargoLookup"
      clearable={true}
      searchComponent={CargoView}
      editComponent={CargoEdit}
      {...props}
      data={{
        ...props.data,
        viewListSearch: true,
      }}
    />
  );
};

export default CargoLookup;
